import { init, getCurrentScope } from '@sentry/react';
import { version } from '../../../../package.json';
import type { IUser } from '@/Interfaces/Data';
import { isProd, SENTRY_DSN } from '../../env';

export const initSentry = () => {
  if (!isProd) {
    return;
  }

  init({
    dsn: SENTRY_DSN,
    release: version,
    enabled: isProd,
  });
};

export const configureSentryScope = (user: IUser) => {
  if (!isProd) {
    return;
  }

  const {
    _id: funcionarioId,
    nome,
    email: funcionarioEmail,
    celular: funcionarioCelular,
    managerLogType: funcionarioRole,
  } = user;

  {
    const scope = getCurrentScope();
    scope.setUser({
      id: funcionarioId,
      username: nome,
      email: funcionarioEmail,
      segment: funcionarioRole,
    });
    scope.setExtras({
      'funcionario.celular': funcionarioCelular,
    });
  }
};
